import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import { DetachedTextBlockEditor } from '@plone/volto-slate/blocks/Text/DetachedTextBlockEditor';
import TextLineEdit from '@plone/volto/components/manage/TextLineEdit/TextLineEdit';
import { flattenToAppURL, isInternalURL } from '@plone/volto/helpers/Url/Url';
import { Container as SemanticContainer, Button } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import config from '@plone/volto/registry';
import { ImageInput } from '@plone/volto/components/manage/Widgets/ImageWidget';
import PersonHeader from '../../Person/PersonHeader';
import Breadcrumbs from '@plone/volto/components/theme/Breadcrumbs/Breadcrumbs';

const PersonBodyTemplate = (props) => {
  const {
    block,
    blocksConfig,
    className,
    data,
    isEditMode,
    onChangeBlock,
    properties,
  } = props;

  const request = useSelector((state) => state.content.subrequests[block]);
  const content = request?.data;

  const customContainer = config.getComponent({ name: 'Container' }).component;

  const Container = customContainer || SemanticContainer;

  return (
    <div className={cx('block pageheader', className)}>
      <PersonHeader content={content || properties} />
      {props.breadcrumbPath && (
        <div className="pageheader-breadcrumbs">
          <Breadcrumbs pathname={props.breadcrumbPath} />
        </div>
      )}
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
PersonBodyTemplate.propTypes = {
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default PersonBodyTemplate;
